<script>
import { VBTooltip } from 'bootstrap-vue';

const FILE_MAX_LENGTH = 42;
const ICON_COMPONENTS_MAP = {
  'pdf': 'IconTextFile',
  'jpg': 'IconImageFile',
  'jpeg': 'IconImageFile',
  'png': 'IconImageFile',
  'jpeg': 'IconImageFile',
  'mp3': 'IconSoundFile',
  'mp4': 'IconVideoFile',
  'webm': 'IconVideoFile',
  'ogg': 'IconVideoFile',
}

export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  methods: {
    truncatedFileName(index) {
      const fileTitle = this.message.files[index].title;
      const fileExtension = this.message.files[index].extension;
      const fileName = `${fileTitle}.${fileExtension}`;
      if (fileName.length <= FILE_MAX_LENGTH) return fileName;
      return fileName.slice(0, FILE_MAX_LENGTH) + '...';
    },

    completeFileName(index) {      
      return `${this.message.files[index].title}.${this.message.files[index].extension}`;
    },

    iconComponentName(index) {
      const componentName = ICON_COMPONENTS_MAP[this.message.files[index].extension];
      if (!componentName) return 'IconFile';
      return componentName;
    },

    openFileModal(index) {
      Bus.$emit('openFileModal', this.message.files[index]);
    }
  }
}
</script>

<template>
  <div class="attendance-message-gallery">
    <button
      v-for="(file, index) in message.files" :key="index"
      @click="openFileModal(index)"
      class="attendance-message-file"
    >
      <Component :is="iconComponentName(index)" />
      <span
        v-b-tooltip
        :title="completeFileName(index).length > 42 ? completeFileName(index) : ''"
        class="text-nowrap"
      >
        {{ truncatedFileName(index) }}
      </span>
    </button> 
  </div>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.attendance-message-gallery {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attendance-message-file {
  width: fit-content;
  display: flex;
  justify-content: center;
  background-color: transparent;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid $salesflow-outline-gray-medium;
  border-radius: 14px;

  @include salesflow-text($font-weight: 600);

  &:hover {
    background-color: $salesflow-outline-gray-light;
  }
}
</style>
